import React, { useMemo } from 'react';

import { breakpoint } from 'utility/constant';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';
import { isNotEmpty } from 'utility/functions';

export const useCodeGameByWindowSize = (codeGameDesktop?: string, codeGameMobile?: string): string => {
  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.lg }]);

  return useMemo(() => {
    if (isMobile && isNotEmpty(codeGameMobile)) {
      return codeGameMobile!;
    }
    if (isNotEmpty(codeGameDesktop)) {
      return codeGameDesktop!;
    }

    return codeGameMobile ?? '';
  }, [codeGameDesktop, codeGameMobile, isMobile]);
};